import { Clipboard } from '@angular/cdk/clipboard';
import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { BasicService } from 'src/app/shared/services/basic.service';

@Component({
  selector: 'app-generate-qr-code',
  templateUrl: './generate-qr-code.component.html',
  styleUrls: ['./generate-qr-code.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class GenerateQrCodeComponent implements OnInit {
  /**
   * The data related to the QR Code.
   */
  @Input() data: string;

  textMaxLength = 150;

  colorChoices = [
    { id: '0', label: this.basicService.translate('accounts/edition/test-link/generate-qr-code/qr-code-color/black') },
    {
      id: '1',
      label: this.basicService.translate('accounts/edition/test-link/generate-qr-code/qr-code-color/whatsapp'),
    },
    { id: '2', label: this.basicService.translate('accounts/edition/test-link/generate-qr-code/qr-code-color/white') },
  ];

  colorsHexadecimal = {
    0: { color: '#000', background: '#ffffff00' },
    1: { color: '#25d366', background: '#ffffff00' },
    2: { color: '#fff', background: '#00000000' },
  };

  form = this.formBuilder.group({
    text: [null, Validators.maxLength(this.textMaxLength)],
    color: [this.colorChoices[0].id, Validators.required],
    url: [{ value: null, disabled: true }],
  });

  constructor(private formBuilder: FormBuilder, private basicService: BasicService, private clipboard: Clipboard) {}

  ngOnInit() {
    this.form.get('url').setValue(this.data);
  }

  generate() {
    const { text } = this.form.value;
    const url = text ? `${this.data}?text=${encodeURIComponent(text)}` : this.data;
    this.form.get('url').setValue(url);
  }

  copyUrl() {
    const { url } = this.form.getRawValue();
    this.clipboard.copy(url);
    this.basicService.toastInformation('accounts/edition/test-link/generate-qr-code/copied');
  }
}
